import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

// Send OTP to email
export const SendOTP = createAsyncThunk(
  "otp/sendOTP",
  async ({ email, type }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/send-otp`,
        { email, type },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Verify OTP
export const VerifyOTP = createAsyncThunk(
  "otp/verifyOTP",
  async ({ email, otp }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/verify-otp`,
        { email, otp },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const OTPSlice = createSlice({
  name: "otp",
  initialState: {
    sendLoading: false,
    verifyLoading: false,
    otpSent: false,
    otpVerified: false,
    error: null,
  },
  reducers: {
    resetOTPState: (state) => {
      state.sendLoading = false;
      state.verifyLoading = false;
      state.otpSent = false;
      state.otpVerified = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Send OTP
      .addCase(SendOTP.pending, (state) => {
        state.sendLoading = true;
        state.error = null;
      })
      .addCase(SendOTP.fulfilled, (state, action) => {
        state.sendLoading = false;
        state.otpSent = action.payload?.data?.success || false;
      })
      .addCase(SendOTP.rejected, (state, action) => {
        state.sendLoading = false;
        state.error = action.payload;
      })
      // Verify OTP
      .addCase(VerifyOTP.pending, (state) => {
        state.verifyLoading = true;
        state.error = null;
      })
      .addCase(VerifyOTP.fulfilled, (state, action) => {
        state.verifyLoading = false;
        state.otpVerified = action.payload?.data?.success || false;
      })
      .addCase(VerifyOTP.rejected, (state, action) => {
        state.verifyLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetOTPState } = OTPSlice.actions;
export default OTPSlice.reducer;
